export const localStorageKeys = {
  BEARER_TOKEN_KEY: 'key_bearer_token',
  USER_KEY: 'key_user',
  CURRENT_COMPANY_KEY: 'key_current_company',
};
